(() => {
  'use strict';
  const VERSION = '2.1.0';
  if (window.BNCollapsibleElite?.version === VERSION) {
    window.BNCollapsibleElite.scan(document);
    return;
  }

  const states = new WeakMap();

  const init = (root) => {
    if (!root || states.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const singleOpen = root.dataset.bnSingleOpen === 'true';
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    const entry = root.dataset.bnEntryAnimation || 'none';
    const details = [...root.querySelectorAll('[data-bn-accordion-details]')];
    const mediaItem = root.querySelector('.collapsible-content__grid-item');
    let observer = null;
    let touchTimer = 0;

    if (singleOpen) {
      details.forEach((item) => item.addEventListener('toggle', () => {
        if (!item.open) return;
        details.forEach((other) => { if (other !== item && other.open) other.open = false; });
      }, { signal }));
    }

    const reveal = () => requestAnimationFrame(() => root.classList.add('is-visible'));
    if (entry !== 'none' && 'IntersectionObserver' in window) {
      root.classList.add('bn-collapsible-motion-armed');
      root.classList.toggle('bn-collapsible-reduced-motion', reduced);
      root.classList.remove('is-visible');
      observer = new IntersectionObserver((entries) => {
        if (entries.some((item) => item.isIntersecting)) {
          reveal();
          observer?.disconnect();
          observer = null;
        }
      }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
      requestAnimationFrame(() => requestAnimationFrame(() => observer?.observe(root)));
    } else {
      reveal();
    }

    const interactMedia = () => {
      if (!mediaItem || root.dataset.bnImageInteraction === 'none') return;
      mediaItem.classList.remove('is-interacted');
      void mediaItem.offsetWidth;
      mediaItem.classList.add('is-interacted');
      window.clearTimeout(touchTimer);
      touchTimer = window.setTimeout(() => mediaItem.classList.remove('is-interacted'), 720);
    };
    mediaItem?.addEventListener('pointerup', (event) => {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') interactMedia();
    }, { signal });

    document.addEventListener('shopify:block:select', (event) => {
      const row = event.target?.closest?.('[data-bn-accordion-row]');
      if (!row || !root.contains(row)) return;
      const selected = row.querySelector('[data-bn-accordion-details]');
      if (selected) selected.open = true;
      root.classList.add('is-visible');
    }, { signal });

    states.set(root, {
      destroy() {
        observer?.disconnect();
        window.clearTimeout(touchTimer);
        controller.abort();
        states.delete(root);
      }
    });
  };

  const scan = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[id^="BNCollapsible-"]')) roots.push(scope);
    scope.querySelectorAll?.('[id^="BNCollapsible-"]').forEach((node) => roots.push(node));
    roots.forEach(init);
  };
  const unload = (scope) => {
    if (!scope) return;
    const roots = [];
    if (scope.matches?.('[id^="BNCollapsible-"]')) roots.push(scope);
    scope.querySelectorAll?.('[id^="BNCollapsible-"]').forEach((node) => roots.push(node));
    roots.forEach((root) => states.get(root)?.destroy());
  };

  window.BNCollapsibleElite = { version: VERSION, scan, unload };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
})();
